import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'

import { useUserStore } from '@/store/user.store'

import { useRolanWealthServiceAuthControllerLogout } from '@/__generated__/queries'

export const useLogout = () => {
  const resetUser = useUserStore.use.resetUser()
  const setCurrentRole = useUserStore.use.setCurrentRole()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const logoutMutation = useRolanWealthServiceAuthControllerLogout({
    onSuccess: () => {
      resetUser()
      setCurrentRole(null)

      queryClient.clear()

      navigate(LoginRoutePathsEnum.LOGIN, { replace: true, state: null })
    },
  })

  return async () => {
    await logoutMutation.mutateAsync()
  }
}
